<template>
    <div>
        <tsoft-table
            :name="'company'"
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            :isNeedSelection="isAgent ? false : true"
            :typeOfTableFilter="isAgent ? '' : 'company'"
            :headerContextMenuName="'companyTable'"
            :externalExportLink="'/export/partner-information'"
            :onDataEmptyMessage="'Не найдено ни одной записи. Попробуйте изменить критерий поиска или добавьте нужную запись.'"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
            :customAddButtonName="'Добавить'"
            @letMeKnowParameter="letMeKnowParameter"
        />

        <tsoft-create-company
            :isSideBarOpenCompany.sync='isSideBarOpenCompany'
            :editIndex.sync="editIndex"
            :editedItem.sync="editedItem"
            :isTransportCompany="isTransportCompanyFilterOpened"
            @create='setCreatedCompany'
            @update='setUpdatedCompany'
            @closeSidePanel='setClosedSidePanelCompany'
            @countryCompany='setCountryCompany'
        />
    </div>
</template>

<script>
    import { API_COMPANY, API_ORDERS } from '@/constants';
    import tsoftCreateCompany from '@components/companies/CreatedOrEditedCompany';

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        dataHelpers
    } from '@/mixins';
    import { mixinDocuments } from '@/mixins/mixinDocuments';
    import { openCompanySidebar } from '@/mixins/openCompanySidebar';

    import { mapGetters } from 'vuex';

    const initialEditedItem = () => ({
        id: '',
        name: '',
        in_russia: 1,
        inn: '',
        kpp: '',
        ogrn: '',
        type: 'LEGAL',
        reference_company_status_id: null,
        is_at_risk: false,
        decline_type_reference_property_id: null,
        decline_type: {},
        sales_manager_user_id: null,
        sales_manager: {},
        reference_sources_id: null,
        source: {},
        reference_property_country_id: 209,
        status: {},
        address: '',
        address_fact: '',
        date_of_opening: '',
        year_certificate_of_residency: null,
		external_sales_manager_name: null,
        phones: '',
        emails: '',
        website: '',
        director: '',
        type_director: '',
        type_of_transport_company: null,
        teo_manager_user_id: null,
        teo_manager: {},
        to_manager_user_id: null,
        to_manager: {},
        reference_friend_type_id: 411,
        friend_type: {},
        motivation_block_all: false,
        motivation_only_escort: false,
        percent_of_mp_to_calc: 100,
        is_transport_company: false,
        is_b2c_rezident: false,
        special_features: [],
        countries_of_branches: [],
        countries_of_rolling_stock: [],
        set_services_ids: [],                       // Virtual for setting up services,
        set_special_features_ids: [],               // Virtual for setting up special_features,
        set_countries_of_branches_ids: [],          // Virtual for setting up countries_of_branches,
        set_countries_of_rolling_stock_ids: [],     // Virtual for setting up countries_of_rolling_stock,
        set_uploading_geography_ids: [],            // Virtual for setting up uploading_geography,
        set_unloading_geography_ids: [],            // Virtual for setting up unloading_geography,
        set_transit_directions_ids: [],             // Virtual for setting up transit_directions,
        set_rf_directions_ids: [],                  // Virtual for setting up rf_directions,
        checked_id: 443,
        checked: {},
        sales_status: 'Готов сейчас',
        lastComment: {},
        clients: [],
        services: [],
        uploading_geography: [],
        unloading_geography: [],
        transit_directions: [],
        rf_directions: []
    })

    export default {
        components: {
            tsoftCreateCompany
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            mixinDocuments,
            openCompanySidebar,
            dataHelpers
        ],
        data() {
            return {
                model_name: ['App\\Models\\Company'],
                changeLoad: false,
                isSideBarOpenCompany: false,
                isSideBarOpenPaymentDetails: false,
                tableApiUrl: API_COMPANY,
                companyOrdersApi: API_ORDERS,
                reloadComponent: 0,
                isTransportCompanyFilterOpened: false
            }
        },
        watch: {
            companyWidgetValue(value) {
                let updated_item = this.items.data.filter(item => item.id === value.id)[0];

                if (updated_item) {
                    updated_item = Object.assign(updated_item, value);
                }
            },
        },
        computed: {
            ...mapGetters('companyDetail', ['companyWidgetValue']),
            ...mapGetters('auth', ['currentUser']),

            isAgent() {
                return (
                    this.currentUser.role.includes("agent")
                );
            }, 
        },
        mounted() {
            this.editedItem = initialEditedItem();
        },
        methods: {
            onCloseSidePanelLoadingDocument(value) {
                if(value == true){
                    this.checkedLoadDocument = false
                }
            },
            // when file updated or loaded
            onFileOperationCompleted(status) {
                this.reloadComponent++
            },
            // calls from mixin on show sidebar company
            onOpenCompanyModalCallback() {
                this.isSideBarOpenCompany = true
            },
            setCreatedCompany(data) {
                this.items.data.unshift(data)
                this.editedItem = initialEditedItem()
            },
            setUpdatedCompany(data) {
                Object.assign(this.items.data[this.editIndex], data)
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
            setClosedSidePanelCompany(){
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
            setCountryCompany(value) {
                this.editedItem = initialEditedItem()
            },
            letMeKnowParameter(param) {
                if (!param) {
                    this.isTransportCompanyFilterOpened = false;
                    return null;
                }

                // Разбор фильтра
                if (param.name === 'additionalParameter') {
                    if (!param.value || param.value === undefined) {
                        this.isTransportCompanyFilterOpened = false;
                    }
                    let tempParams = this.queryStringToObject(param.value);

                    for(const key in tempParams) {
                        if (key == 'is_transport_company') {
                            this.isTransportCompanyFilterOpened = true;
                        }
                    }
                }
            }
        }
    }
</script>
